import { useEffect, useMemo, useState } from 'react'

import useApi from './useApi'
import { effectiveMinimumPledgeForEvent } from '../lib/effectiveMinimumPledge'

// from GET /events/:id when needed and falling back to platform default from settings

export default function useSponsorPledgeMinimumCiv({ show, event }) {
  const { getEvent, getDefaultMinimumRequiredPledgeAmount } = useApi()
  const [pledgeEvent, setPledgeEvent] = useState(event)
  const [settingsDefault, setSettingsDefault] = useState(null)

  useEffect(() => {
    if (!show) return
    setPledgeEvent(event)
  }, [show, event])

  useEffect(() => {
    if (!show || !event?.id || !event?.volunteer_pay_forward) {
      setSettingsDefault(null)
      return
    }
    let cancelled = false
    getEvent({ id: event.id }).then(res => {
      if (!cancelled && res?.data) setPledgeEvent(res.data)
    })
    return () => {
      cancelled = true
    }
  }, [show, event?.id, event?.volunteer_pay_forward])

  useEffect(() => {
    if (!show || !pledgeEvent?.volunteer_pay_forward) {
      setSettingsDefault(null)
      return
    }
    if (pledgeEvent.effective_minimum_required_pledge_amount != null) return
    if (pledgeEvent.minimum_required_pledge_amount != null) return
    let cancelled = false
    getDefaultMinimumRequiredPledgeAmount().then(res => {
      if (!cancelled && res?.data) {
        setSettingsDefault(
          res.data.default_minimum_required_pledge_amount ?? null,
        )
      }
    })
    return () => {
      cancelled = true
    }
  }, [
    show,
    pledgeEvent?.volunteer_pay_forward,
    pledgeEvent?.effective_minimum_required_pledge_amount,
    pledgeEvent?.minimum_required_pledge_amount,
  ])

  const minimumPledgeCiv = useMemo(
    () => effectiveMinimumPledgeForEvent(pledgeEvent, settingsDefault),
    [pledgeEvent, settingsDefault],
  )

  return { pledgeEvent, minimumPledgeCiv }
}
